export interface ApplicationDetail {
  isFullService?: boolean;
  creditUnionService: string;
  hasRecommendation?: boolean;
  analystRecomendation?: string;
  conciergeRequest: string;
  lenderName?: string;
  expiration: string;
  esignExpiration: string;
}

export enum NationalIdNumberTypes {
  SSN = 1,
  ITIN = 2,
}

export class NationalIdNumberTypeIds {
  public static get SSN(): number {
    return NationalIdNumberTypes.SSN;
  }

  public static get ITIN(): number {
    return NationalIdNumberTypes.ITIN;
  }
}
export interface NationalIdNumberTypeDefinition {
  id: number;
  abbreviation: string;
  name: string;
}

export const NationalIdNumberTypeDefinitions: Readonly<
  Record<number, NationalIdNumberTypeDefinition>
> = {
  [NationalIdNumberTypeIds.ITIN]: {
    id: NationalIdNumberTypeIds.ITIN,
    name: "Individual Taxpayer Identification Number",
    abbreviation: "ITIN",
  },
  [NationalIdNumberTypeIds.SSN]: {
    id: NationalIdNumberTypeIds.SSN,
    name: "Social Security Number",
    abbreviation: "SSN",
  },
};
